import styled from "styled-components";

export const Language = styled.div`
 .teste {
        padding: 10px 0 20px 0px;
        border-radius: 10px;
        box-shadow: 0px 0px 10px rgba(0,0,0,0.25);
    }
    h2{
        font-size: 24px;
        font-weight: 500;
        color: #87868F;
        margin: 25px 0 30px 100px;
    }

    .input-lingo {
        width: 200px;
        height: 32px;
    }


    .planInfo{
        margin: 0 0 0 100px;
        h3{
            font-size: 20px;
            font-weight: 500;
            color: #004FFF;
            margin: 32px 0 15px 0;
        }

        /** Form **/
        .formulario{
            display: flex;
            justify-content: center;
            flex-direction: column;
            margin: 15px 0 0 0;
            width: 100%;

            label{
                color: #403F4C;
                font-size: 14px;
                font-weight: bold;
            }

            span{
                color: #87868F;
                font-size: 10px;
                margin-left: 5px;
            }

            input{
                width: 190px;
                height: 32px;
                border-radius: 26px;
                border: 1px solid #B2B2B7;
                color: #403F4C;
                padding-left: 10px;
                margin-bottom: 15px;

                &:nth-child(3){
                    width: 627px;
                }
            }

            .switch__container{
                margin: 5px auto 12px;

                span{
                    margin-left: 50px;
                }
            }

            .switch--shadow:checked + label:before {
                background-color: #4DBD74;
            }

            .numberClass{
                margin: 10px 0 0 20px;
                input{
                    width: 200px;
                }
            }

            .country{
                display: flex;

                .countryTop{
                    flex-direction: column;
                    display: flex;
                    margin: 0 13px 0 0;
                }


            }

        }

        .deleteType{
            border: 1px solid #FF5666;
            border-radius: 26px;
            color: #FF5666;
            font-size: 12px;
            font-weight: 500;
            background-color: transparent;
            width: 85px;
            height: 22px;
            cursor: pointer;
            margin: 0 0 10px 0;

            &:last-child{
                width: auto;
                margin: 10px 0 25px 0;
                min-height: 22px;
                text-transform: none;
                line-height: 0;
            }

            span{
                color: #FF5666;
                margin: 0;
            }
        }


    }

    .button{
        display: flex;
        width: 100%;
        justify-content: flex-end;
        margin-top: 15px;

        button.save{
          padding: 10px 20px;
            height: 38px;
            border-radius: 26px;
            background: #004FFF;
            border: 1px solid #004FFF;
            color: #fff;
            cursor: pointer;
            font-size: 14px;
            font-weight: bold;
            margin: 24px 0 30px 0;
            font-family: 'Work Sans', sans-serif;
        }

        button.back{
            width: 72px;
            height: 28px;
            border-radius: 26px;
            background: transparent;
            border: 1px solid #787780;
            color: #787780;
            cursor: pointer;
            font-size: 11px;
            font-weight: bold;
            margin: 30px 15px 30px 0px;
            font-family: 'Quicksand', sans-serif;

            .fa{
                margin-right: 3px;
            }
        }
    }
`;

export const Table = styled.div`

    .bigBoxTableCountries{
        width: auto;
        padding: 10px 15px;
        border-radius: 10px;
        background-color: #ffffff;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);

        table{
            width: 100%;
            border: none;
            border-collapse: collapse;
            background-color: #ffffff;

            tr {
                text-align: left;
                height: 35px;

                th{
                    color: #403f4c;
                    font-size: 12px;
                    font-weight: bold;
                }

                :nth-child(2){
                    border-top: 1px solid #B2B2B7;
                }
            }

            td {
                position: relative;
                border-bottom: 1px solid #B2B2B7;
                height: 33px;
                font-size: 14px;
                color: #403f4c;
                font-weight: 400;
                font-family: "Work Sans", sans-serif;
                padding: 4px 0;

                .activo{
                    color: #0ED572;
                    font-weight: bold;
                }
                .inativo{
                    color: #FF5666;
                    font-weight: bold;
                }
                button{
                    background-color: transparent;
                    border: 1px solid #B2B2B7;
                    border-radius: 26px;
                    color: #87868F;
                    font-size: 11px;
                    width: 58px;
                    height: 22px;
                    float: right;
                    cursor: pointer;
                }
            }
        }
    }

    .buttons{
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-end;
        margin: 0 0 30px;
        padding: 0 15px 0 15px;
        cursor: pointer;
        width: 94%;
        cursor: pointer;

        .fa{
            margin-right: 3px;
        }


        button{
            background-color: transparent;
            border: 1px solid #787780;
            color: #403F4C;
            font-weight: bold;
            font-size: 14px;
            border-radius: 26px;
            width: 71px;
            height: 28px;
            margin-top: 8px;
            margin-left: 20px;
            cursor: pointer;

            &:last-child{
                background-color: #004FFF;
                border: none;
                color: #fff;
                font-weight: bold;
                font-size: 14px;
                border-radius: 26px;
                width: 180px;
                height: 38px;
                margin: 5px 20px 0 0;
                cursor: pointer;
            }
        }
    }

`;
